import Vue from 'vue';
import Vuex from 'vuex';
import promotionManagement from './promotionManagement';
import newPromotion from './newPromotion';
import autoOptimization from './autoOptimization';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: false, //加载动画开关
        loadingQueue: [], //请求队列,队列为空时关闭loading
        loadingTimeOut: '',
        manageData: {
            series: {},
            group: {},
            ad: {},
        },
        userData: {
            accountType: '',
            email: '',
            source: '',
            autoType: 0,
        },
    },
    mutations: {
        loading(state, bool) {
            if (bool) clearTimeout(state.loadingTimeOut);
            state.loading = bool;
        },
        loadingQueue(state, arr) {
            state.loadingQueue = arr;
        },
        loadingTimeOut(state, value) {
            state.loadingTimeOut = value;
        },
        setUserData(state, value) {
            state.userData = {
                source: '',
                ...value,
            };
        },
        controlManagement(state, data) {
            if (data.name === 'clear') {
                console.log('data-clear', data);
                state.manageData.series = {};
                state.manageData.group = {};
                state.manageData.ad = {};
            } else if (data.name === 'clear-group') {
                console.log('data-clear-group', data);
                state.manageData.group = {};
            } else if (data.name === 'clear-ad') {
                console.log('data-clear-ad', data);
                state.manageData.ad = {};
            } else {
                let obj = state.manageData[data.name];
                state.manageData[data.name] = Object.assign({}, obj, data.value);
            }
        },
    },
    actions: {
        /*
         * @decription 开启加载动画
         */
        openLoading({ commit, state }) {
            clearTimeout(state.loadingTimeOut);
            commit('loading', true);
            commit('loadingQueue', [...state.loadingQueue, true]);
        },
        /*
         * @decription 关闭加载动画
         * @param duration:number 延迟关闭loading的时间
         */
        closeLoading({ commit, state }, duration = 500) {
            clearTimeout(state.loadingTimeOut);
            const arr = [...state.loadingQueue];
            arr.pop();
            commit('loadingQueue', arr);
            //全部请求完毕关闭loading
            if (!arr.length) {
                commit('loadingTimeOut', setTimeout(() => commit('loading', false), duration));
            }
        },
        mangeData({ commit, state }, data) {
            commit('controlManagement', data);
        },
    },
    modules: {
        autoOptimization,
        promotionManagement,
        newPromotion
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js